import type { NavSidebarMode, UserPreferences } from '@maxiron/shared';

export function navModeFromPreferences(preferences: UserPreferences | undefined): NavSidebarMode {
  const mode = preferences?.navSidebarMode;
  if (mode === 'expanded' || mode === 'thin' || mode === 'hidden') {
    return mode;
  }
  return preferences?.navSidebarCollapsed === true ? 'hidden' : 'expanded';
}

export function nextNavMode(current: NavSidebarMode): NavSidebarMode {
  const order: NavSidebarMode[] = ['expanded', 'thin', 'hidden'];
  const i = order.indexOf(current);
  return order[(i + 1) % order.length];
}
